import TweenMax from 'gsap';
const cerr = window.console.error;

class Preloader {
    constructor(element) {
        if (element instanceof Element) {
            this._element = element;
            this._progress = 0;
            this._render();
        } else {
            cerr('Passed argument element is not instance of HTMLElement');
        }
    }

    set progress(value) {
        if (value === this._progress) return this._progress;
        this._progress = value;
        this._render();
    }

    get progress() {
        return this._progress;
    }

    _render() {
        TweenMax.set(this._element, {yPercent: (1 - this._progress) * 100});
    }
}


module.exports.Preloader = Preloader;



// WEBPACK FOOTER //
// ./js/preoader.js